import type { FlowsView } from "../../enums/scan";
import { FLOWS_VIEW } from "../../enums/scan";

export function FlowsViewToggle(props: {
  view: FlowsView;
  onChange: (view: FlowsView) => void;
}) {
  return (
    <fieldset
      class="flows-view-toggle"
      aria-label="Content and messaging flow view"
    >
      <button
        type="button"
        class={props.view === FLOWS_VIEW.STRUCTURE ? "is-active" : ""}
        aria-pressed={props.view === FLOWS_VIEW.STRUCTURE}
        onClick={() => props.onChange(FLOWS_VIEW.STRUCTURE)}
      >
        Current structure
      </button>
      <button
        type="button"
        class={props.view === FLOWS_VIEW.PATHS ? "is-active" : ""}
        aria-pressed={props.view === FLOWS_VIEW.PATHS}
        onClick={() => props.onChange(FLOWS_VIEW.PATHS)}
      >
        Current Paths
      </button>
    </fieldset>
  );
}
